import Affix from './Affix.vue';
export default Affix;



// WEBPACK FOOTER //
// ./src/components/affix/index.js